import {
	usePermissions, useNotify, useRedirect, useTranslate,
	TopToolbar, ListButton, Create,
	SimpleForm, TextInput
} from 'react-admin';
import { Helmet } from 'react-helmet-async';

const CustomActions = () => (
	<TopToolbar>
		<ListButton />
	</TopToolbar>
);

export const SeedlingCreate = () => {
	const translate = useTranslate();
	const { permissions, isLoading } = usePermissions();
	const notify = useNotify();
	const redirect = useRedirect();
	
	const pageTitle = translate('resources.seedling.create');
	const systemName = translate('system.name');
	
	if (isLoading) return null;
	
	if (permissions !== 'admin') {
		notify('この機能にアクセスする権限がありません', { type: 'warning' });
		redirect('/seedling');
		return null;
	}
	
	return (
		<>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<Create actions={<CustomActions />} title={pageTitle} redirect="list" mutationOptions={{ meta: { mode: 'kanri' } }}>
				<SimpleForm>
					<TextInput source="planting_date" />
					<TextInput source="variety" />
					<TextInput source="target_count" />
					<TextInput source="harvest_date" />
					<TextInput source="cutting_count" />
					<TextInput source="yield_count" />
				</SimpleForm>
			</Create>
		</>
	);
};

export default SeedlingCreate;
